import { render, staticRenderFns } from "./NotFoundPersonList.vue?vue&type=template&id=60cd1d9e"
import script from "./NotFoundPersonList.vue?vue&type=script&lang=js"
export * from "./NotFoundPersonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports